import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import ChequeContractList from "../../components/ChequeContract/List/ChequeContractList";
import { withRouter } from "react-router";

const ChequeContractListUserPage = (props) => {
  return (
    <Wrapper>
      <ChequeContractList
        name={props.match.params.name}
        user={props.match.params.id}
      />
    </Wrapper>
  );
};

export default withRouter(ChequeContractListUserPage);
